export default __webpack_public_path__ + "static/sj-8caf8cfb656b71464fe1b15c9f6f44fd.jpg";